import { createFileRoute } from '@tanstack/react-router'
import { ImpressumPage } from '~/features/landing/LegalPage'

export const Route = createFileRoute('/impressum')({
  component: ImpressumPage,
})
